import { Loader2 } from "lucide-react";
import { PixelatedLoader } from "@/components/ui/feedback";

export function GenerationBootingState() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        {/* Animated Pixelated Logo */}
        <div className="mb-8">
          <PixelatedLoader size="lg" />
        </div>

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-white mb-2">
          Booting Up Your Generation
        </h1>
        <p className="text-[#888] mb-8">This should take a couple of seconds</p>

        {/* Loading indicator */}
        <div className="flex items-center justify-center gap-2 text-[#888]">
          <Loader2 className="size-5 animate-spin text-violet-400" />
          <span>Initializing</span>
        </div>
      </div>
    </div>
  );
}
